export const ACTIVE_EVENT_LUCKY_MOON = "ACTIVE_EVENT_LUCKY_MOON";
export const GET_LANTERN_COLLECTION = "GET_LANTERN_COLLECTION";
export const SPIN_LUCKY_MOON = "SPIN_LUCKY_MOON";
export const GET_RANK_TABLE = "GET_RANK_TABLE";
// export const GET_MY_RANK_TABLE = "GET_MY_RANK_TABLE";
export const GET_HISTORY_LUCKY_MOON = "GET_HISTORY_LUCKY_MOON";
export const POST_PAIRING = "POST_PAIRING"